module.exports = __webpack_public_path__ + "img/logo.06db42b6.png";